<form (submit.prevent)="onSubmit()">
  <app-parse-request-create-accordion [state]="state()" activeStep="GENERAL">
    <div slot="general-form" class="flex flex-col gap-6 @container">
      <ui-alert>
        <ng-icon slot="icon" name="heroInformationCircle" size="20" class="!block" />
        <h3 slot="title">
          {{ 'cockpit.parseRequests.createGeneral.tip.title' | transloco }}
        </h3>
        <p>
          {{ 'cockpit.parseRequests.createGeneral.tip.description' | transloco }}
        </p>
      </ui-alert>

      <ui-input-label>
        {{ 'cockpit.parseRequests.createGeneral.businessRelation.label' | transloco }}
        <span class="text-error dark:text-error-darkmode">*</span>
        <ui-radio-group [formField]="form.businessRelation" class="vertical @2xl:horizontal">
          <ui-radio value="NONE">
            {{ 'cockpit.parseRequests.createGeneral.businessRelation.none' | transloco }}
          </ui-radio>
          <ui-radio value="SUPPLIER">
            {{ 'cockpit.parseRequests.createGeneral.businessRelation.supplier' | transloco }}
          </ui-radio>
          <ui-radio value="BROKER">
            {{ 'cockpit.parseRequests.createGeneral.businessRelation.broker' | transloco }}
          </ui-radio>
        </ui-radio-group>
        <app-field-errors slot="bottom" [fieldState]="form.businessRelation()" />
      </ui-input-label>

      <ui-input-label [class.hidden]="form.businessPartnerName().disabled()">
        {{ 'cockpit.parseRequests.createGeneral.businessPartnerName.label' | transloco }}
        <span class="text-error dark:text-error-darkmode">*</span>
        <ui-input-simple type="text" [formField]="form.businessPartnerName" />
        <app-field-errors slot="bottom" [fieldState]="form.businessPartnerName()" />
      </ui-input-label>

      <ui-input-label>
        {{ 'cockpit.parseRequests.createGeneral.satisfied.label' | transloco }}
        <span class="text-error dark:text-error-darkmode">*</span>
        <ui-radio-group [formField]="form.satisfied" class="vertical @md:horizontal">
          <ui-radio value="YES">
            {{ 'cockpit.parseRequests.createGeneral.satisfied.yes' | transloco }}
          </ui-radio>
          <ui-radio value="NO">
            {{ 'cockpit.parseRequests.createGeneral.satisfied.no' | transloco }}
          </ui-radio>
        </ui-radio-group>
        <app-field-errors slot="bottom" [fieldState]="form.satisfied()" />
      </ui-input-label>

      <ui-input-label [class.hidden]="form.unsatisfiedReason().disabled()">
        {{ 'cockpit.parseRequests.createGeneral.unsatisfiedReason.label' | transloco }}
        <span class="text-error dark:text-error-darkmode">*</span>
        <ui-radio-group [formField]="form.unsatisfiedReason" class="vertical @2xl:horizontal">
          <ui-radio value="HIGH_PRICE">
            {{ 'cockpit.parseRequests.createGeneral.unsatisfiedReason.highPrice' | transloco }}
          </ui-radio>
          <ui-radio value="INTRANSPARENT">
            {{ 'cockpit.parseRequests.createGeneral.unsatisfiedReason.intransparent' | transloco }}
          </ui-radio>
          <ui-radio value="OTHER">
            {{ 'cockpit.parseRequests.createGeneral.unsatisfiedReason.other' | transloco }}
          </ui-radio>
        </ui-radio-group>
        <app-field-errors slot="bottom" [fieldState]="form.unsatisfiedReason()" />
      </ui-input-label>

      <ui-input-label [class.hidden]="form.unsatisfiedOtherReason().disabled()">
        {{ 'cockpit.parseRequests.createGeneral.unsatisfiedOtherReason.label' | transloco }}
        <span class="text-error dark:text-error-darkmode">*</span>
        <ui-input-simple type="text" [formField]="form.unsatisfiedOtherReason" />
        <app-field-errors slot="bottom" [fieldState]="form.unsatisfiedOtherReason()" />
      </ui-input-label>
    </div>
    <div slot="general-form" class="empty:hidden text-end">
      @if (showValidationErrors() && form().invalid()) {
        <ui-input-error>
          {{ 'cockpit.parseRequests.createGeneral.validationError' | transloco }}
        </ui-input-error>
      }

      @if (updateError()) {
        <ui-input-error>
          {{ 'cockpit.parseRequests.createGeneral.updateError' | transloco }}
        </ui-input-error>
      }
    </div>

    <div slot="general-footer" class="grid grid-cols-1 gap-2 @md/general-footer:grid-cols-2">
      <div class="@md/general-footer:flex">
        <ui-button
          type="button"
          expand="full"
          mode="outlined"
          [routerLink]="['../documents']"
          [relativeTo]="activatedRoute"
        >
          <ng-icon name="heroChevronLeft" size="20" class="!block" slot="start" />
          {{ 'cockpit.parseRequests.createGeneral.backButton' | transloco }}
        </ui-button>
      </div>
      <div class="@md/general-footer:flex justify-end gap-2">
        <ui-button type="submit" expand="full" [loading]="isUpdateLoading()">
          {{ 'cockpit.parseRequests.createGeneral.nextStep' | transloco }}
          <ng-icon name="heroChevronRight" size="20" class="!block" slot="end" />
        </ui-button>
      </div>
    </div>
  </app-parse-request-create-accordion>
</form>
